import React, { useMemo } from 'react'
import { default as NoticeView, NoticeViewProps } from './NoticeView'

/**
 * NoticesView component
 * author: soojin.oh
 */

// type definitions
type NoticesViewProps = { notices?: (NoticeViewProps | null)[] }

// NoticesView component
const NoticesView: React.FunctionComponent<NoticesViewProps> = function ({ notices }) {
  const noticesView = useMemo(
    () =>
      notices
        ?.filter(v => v)
        .map((notice, index) => (
          <NoticeView title={notice?.title} contents={notice?.contents} key={index} />
        )),
    [notices]
  )
  return <>{noticesView}</>
}

export default NoticesView
